import productCostService from '../services/productcost.service';
import PartnerService from '../services/partner.service';
import moment from 'moment'


let today = new Date();
const getDefaultState = () => {
  return {
    contract_id: "",
    receiving_voucher_id: "",
    supplier_id: null,
    supplier_code: "",
    cost_type: 3,
    issue_date: moment(today).format("YYYY-MM-DD"),
    category_cost: 1,
    supplier_inv_no: null,
    supplier_inv_date: null,
    cost_name: "",
    cost_amount: null,
    cost_tax: null,
    payment_due_date: null,
    actual_payment_date: null,
    cost_actual_amount: null,
    remark: "",
    status: 1
  }
}

export const productCostReceiving = {
    namespaced: true,
    state: {
      stateData: getDefaultState()
    },
    actions: {
      resetState({commit}) {
        commit("resetState");
      },
      getListSupplierService({commit}, page=1, size=-1, type="1,3") {
        return productCostService.getListPartner(page, size, type).then(
          (response) => {
            return Promise.resolve(response);
          },
          (error) => {
            commit('getListSupplierServiceFailure');
            return Promise.reject(error);
          }
        );
      },
      getProductCostDetailForModalByReceivingID({commit}, id) {
        return productCostService.getProductCostDetailForModalByReceivingID(id).then(
          (response) => {
            commit('getProductCostDetailForModalByReceivingIDSuccess', response);
            return Promise.resolve(response);
          },
          (error) => {
            commit('getProductCostDetailForModalByReceivingIDFailure');
            return Promise.reject(error);
          }
        );
      },
      createReceivingProductCostModal({commit}, data) {
        return productCostService.createReceivingProductCostModal(data).then(
          (response) => {
            return Promise.resolve(response);
          },
          (error) => {
            commit("createReceivingProductCostModalFailure");
            return Promise.reject(error);
          }
        );
      },
      updateReceivingProductCostModal({commit}, data) {
        return productCostService.updateReceivingProductCostModal(data).then(
          (response) => {
            return Promise.resolve(response);
          },
          (error) => {
            commit("updateReceivingProductCostModalFailure");
            return Promise.reject(error);
          }
        );
      },
      getSupplierInfo({commit}, id) {
        return PartnerService.getPartnerInfo(id).then(
          (response) => {
            return Promise.resolve(response);
          },
          (error) => {
            commit('getPartnerFailure');
            return Promise.reject(error);
          }
        );
      }
    },
    mutations: {
      resetState (state) {
        console.log("run resetState");
        Object.assign(state.stateData, getDefaultState());
      },
      getListSupplierSuccess(state, response) {
        state.stateData.list_suppliers = response.listItems
      },
      getListSupplierFailure(state) {
        state.stateData.list_suppliers = [];
      },
      getProductCostDetailForModalByReceivingIDSuccess(state, response) {
        // Object.assign(state.stateData, getDefaultState());
        state.stateData = {...state.stateData, ...response};
      }
    }
}